<ym-topbar class="ym-display-block ym-border-b-1 ym-border-b-solid ym-border-gray-a-16">
    <ng-container left>
        {{title}}
    </ng-container>
    <ng-container right>
        <!-- <ym-button [variant]="buttonVariants.ICON_ONLY" [icon]="iconNames.BELL"
            [type]="buttonTypes.GHOST">Notification</ym-button> -->

        <ng-container *ngIf="userDocument">
            <a [routerLink]="settingsRoute"
                class="avatar ym-focus--focus ym-p-2 ym-ml-n2 ym-rounded-full ym-border-none ym-bg-transparent ym-transition-duration-medium ym-active-shadow-button-inset">
                <ym-avatar [name]="userDocument.first_name|| userDocument.email" [src]="userDocument.avatar"
                    [size]="avatarSizes.LG"></ym-avatar>
            </a>
        </ng-container>
    </ng-container>
</ym-topbar>